import React from "react";
import { Alert, Badge, Card, Button, Carousel } from "react-bootstrap";
import { IoPencil, IoAddCircle, IoRemoveCircle } from "react-icons/io5";

interface IInstructorCourse {
  title?: string;
  img?: any;
  approve: boolean;
  price_per_class: number;
  instrument: any;
  deleted: boolean;
  isVisible: boolean;
  onEditClick: any;
  international_discounts: any;
  discount: any;
}

const CustomCard = (props: IInstructorCourse) => {
  let { international_discounts } = props;

  international_discounts.filter((dis: any) => {
    return dis?.country != "India";
  })

  if (props.discount && props.discount.length > 0) {
    international_discounts.push({
      country: "India",
      discount: props.discount || []
    })
  }

  return (
    <div className="m-3">
      <Card style={{ width: "300px", minHeight: "350px" }}>
        <Card.Body>
          <div>
            <img src={props.img} width="100%" height="100px" className="rounded" />
          </div>

          <div className="mt-3">
            <div className="text-secondary d-flex align-items-center">
              <span className="fw-bold xcn-text-18">{props.title}</span>
              <span className="ms-2">
                <IoPencil className="cursor-pointer" onClick={props.onEditClick} />
              </span>
            </div>
            {props.instrument && <span className="fs-12 fw-bold">Instrument: {props.instrument}</span>}
            {props.price_per_class && <span className="fs-12 d-block">Price Per Class: {props.price_per_class}</span>}
          </div>

          {international_discounts?.length > 0 && (
            <Carousel indicators={false} controls={false} interval={3000} pause={false} className="mt-3">
              {international_discounts.map((dis: any, countryIndex: number) => (
                <Carousel.Item key={countryIndex}>
                  <Alert className="fs-12 p-2" variant="warning">
                    <strong className="text-primary">{dis?.country}</strong>
                    {dis?.discount?.map((data: any, discountIndex: number) => (
                      <div key={discountIndex} className="d-flex align-items-center gap-2 mt-2">
                        <span className="fw-bold">{data.num_classes} classes</span>
                        <span>get</span>
                        <span className="text-success fw-bold">{data.discount}% off</span>
                      </div>
                    ))}
                  </Alert>
                </Carousel.Item>
              ))}
            </Carousel>
          )}

          <div className="d-flex justify-content-start align-items-center gap-2">
            <Badge bg={props.approve ? "success" : "danger"}>
              {props.approve ? "Approved" : "Not Approved"}
            </Badge>
            <Badge bg={props.isVisible ? "primary" : "danger"}>
              {props.isVisible ? "Visible" : "Not Visible"}
            </Badge>
            {props.deleted && <Badge bg="danger">Deleted</Badge>}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CustomCard;
